//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AxiosResponse as AR } from 'axios';
import { config, getAccessToken } from './AADHelper';
import * as JSONDecycle from './JSONDecycle';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class IConfig {
    public getAuthorization = () => {
        return getAccessToken([config.scopes.api]);
    };
}

export class AuthorizedApiBase {
    protected readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }

    protected getCookie = (name: string): string | null => {
        const nameLenPlus = (name.length + 1);
        return document.cookie
            .split(';')
            .map(c => c.trim())
            .filter(cookie => {
                return cookie.substring(0, nameLenPlus) === `${name}=`;
            })
            .map(cookie => {
                return decodeURIComponent(cookie.substring(nameLenPlus));
            })[0] || null;
    }

    protected transformOptions = async (options: any): Promise<any> => {
        if (options.headers.skipauth || options.headers.skipauth === '') {
            var { skipauth, ...headers } = options.headers;
            options.headers = headers;
        }
        else {
            options.headers = {
                ...options.headers,
                Authorization: "Bearer " + await this.config.getAuthorization(),
            };
        }

        const xsrfToken = this.getCookie("X-XSRF-TOKEN");
        if (xsrfToken)
            options.headers = {
                ...options.headers,
                "X-XSRF-TOKEN": xsrfToken,
            };
        return Promise.resolve(options);
    };

    protected transformResult = (url_: string, response: AR<any>, callback: (_response: AR) => Promise<any>): any => {
        if (response.headers['content-disposition'] && response.headers['content-disposition'].indexOf('attachment') > -1)
            return callback(response);
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (_responseText === "")
                result200 = resultData200;
            else {
                if (typeof resultData200 === 'string')
                    result200 = JSON.parse(resultData200);
                result200 = JSONDecycle.removeReferencePointers(result200);
            }
            return Promise.resolve<any>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export class AdminClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    analysis( cancelToken?: CancelToken): Promise<DataAnalysisDTO[]> {
        let url_ = this.baseUrl + "/api/admin/analysis";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAnalysis(_response));
        });
    }

    protected processAnalysis(response: AxiosResponse): Promise<DataAnalysisDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataAnalysisDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataAnalysisDTO[]>(null as any);
    }

    orderAnalysis(orderId?: string | undefined, cancelToken?: CancelToken): Promise<DataAnalysisDTO[]> {
        let url_ = this.baseUrl + "/api/admin/orderAnalysis?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOrderAnalysis(_response));
        });
    }

    protected processOrderAnalysis(response: AxiosResponse): Promise<DataAnalysisDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataAnalysisDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataAnalysisDTO[]>(null as any);
    }

    entityAnalysis(entityId?: string | undefined, cancelToken?: CancelToken): Promise<DataAnalysisDTO[]> {
        let url_ = this.baseUrl + "/api/admin/entityAnalysis?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEntityAnalysis(_response));
        });
    }

    protected processEntityAnalysis(response: AxiosResponse): Promise<DataAnalysisDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataAnalysisDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataAnalysisDTO[]>(null as any);
    }

    refreshConfiguration( cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/admin/refreshConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshConfiguration(_response));
        });
    }

    protected processRefreshConfiguration(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    configuration( cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/admin/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfiguration(_response));
        });
    }

    protected processConfiguration(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    updateConfiguraiton(cfg: { [key: string]: string; }, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/admin/updateConfiguraiton";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cfg);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateConfiguraiton(_response));
        });
    }

    protected processUpdateConfiguraiton(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    catalog( cancelToken?: CancelToken): Promise<ServiceOfferDTO[]> {
        let url_ = this.baseUrl + "/api/admin/catalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCatalog(_response));
        });
    }

    protected processCatalog(response: AxiosResponse): Promise<ServiceOfferDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ServiceOfferDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOfferDTO[]>(null as any);
    }

    serviceOffer(id?: string | undefined, cancelToken?: CancelToken): Promise<ServiceOfferDTO> {
        let url_ = this.baseUrl + "/api/admin/serviceOffer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processServiceOffer(_response));
        });
    }

    protected processServiceOffer(response: AxiosResponse): Promise<ServiceOfferDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ServiceOfferDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOfferDTO>(null as any);
    }

    orders( cancelToken?: CancelToken): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/api/admin/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOrders(_response));
        });
    }

    protected processOrders(response: AxiosResponse): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrderDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    updateOrderStatus(orderId?: string | undefined, status?: OrderStatus | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/updateOrderStatus?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateOrderStatus(_response));
        });
    }

    protected processUpdateOrderStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cleanPendingUploads( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/CleanPendingUploads";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCleanPendingUploads(_response));
        });
    }

    protected processCleanPendingUploads(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pendingUploads( cancelToken?: CancelToken): Promise<FlowFileUpload[]> {
        let url_ = this.baseUrl + "/api/admin/PendingUploads";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPendingUploads(_response));
        });
    }

    protected processPendingUploads(response: AxiosResponse): Promise<FlowFileUpload[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FlowFileUpload[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlowFileUpload[]>(null as any);
    }

    chunkStates(fileId?: string | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: ChunkState; }> {
        let url_ = this.baseUrl + "/api/admin/ChunkStates?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChunkStates(_response));
        });
    }

    protected processChunkStates(response: AxiosResponse): Promise<{ [key: string]: ChunkState; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: ChunkState; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: ChunkState; }>(null as any);
    }

    deleteOrder(orderId?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/deleteOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteOrder(_response));
        });
    }

    protected processDeleteOrder(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    entities( cancelToken?: CancelToken): Promise<EntityAdminDTO[]> {
        let url_ = this.baseUrl + "/api/admin/entities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEntities(_response));
        });
    }

    protected processEntities(response: AxiosResponse): Promise<EntityAdminDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityAdminDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityAdminDTO[]>(null as any);
    }

    setEntityRights(entityId?: string | undefined, userID?: string | undefined, rights?: Rights | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/setEntityRights?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (userID === null)
            throw new Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (rights === null)
            throw new Error("The parameter 'rights' cannot be null.");
        else if (rights !== undefined)
            url_ += "rights=" + encodeURIComponent("" + rights) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetEntityRights(_response));
        });
    }

    protected processSetEntityRights(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    users( cancelToken?: CancelToken): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/admin/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUsers(_response));
        });
    }

    protected processUsers(response: AxiosResponse): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    updateRole(userRoles: UserRoleRequestDTO[], cancelToken?: CancelToken): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/admin/updateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRoles);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRole(_response));
        });
    }

    protected processUpdateRole(response: AxiosResponse): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    features( cancelToken?: CancelToken): Promise<Feature[]> {
        let url_ = this.baseUrl + "/api/admin/Features";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFeatures(_response));
        });
    }

    protected processFeatures(response: AxiosResponse): Promise<Feature[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Feature[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Feature[]>(null as any);
    }

    editFeatures(features: string[], userId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/EditFeatures?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(features);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditFeatures(_response));
        });
    }

    protected processEditFeatures(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    availableModules( cancelToken?: CancelToken): Promise<WorkflowModuleDefinition[]> {
        let url_ = this.baseUrl + "/api/admin/availableModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAvailableModules(_response));
        });
    }

    protected processAvailableModules(response: AxiosResponse): Promise<WorkflowModuleDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowModuleDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowModuleDefinition[]>(null as any);
    }

    workflows(serviceOfferId?: string | undefined, cancelToken?: CancelToken): Promise<Workflow[]> {
        let url_ = this.baseUrl + "/api/admin/workflows?";
        if (serviceOfferId === null)
            throw new Error("The parameter 'serviceOfferId' cannot be null.");
        else if (serviceOfferId !== undefined)
            url_ += "serviceOfferId=" + encodeURIComponent("" + serviceOfferId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWorkflows(_response));
        });
    }

    protected processWorkflows(response: AxiosResponse): Promise<Workflow[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Workflow[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Workflow[]>(null as any);
    }

    getWorkflow(serviceOfferId?: string | undefined, id?: string | null | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/getWorkflow?";
        if (serviceOfferId === null)
            throw new Error("The parameter 'serviceOfferId' cannot be null.");
        else if (serviceOfferId !== undefined)
            url_ += "serviceOfferId=" + encodeURIComponent("" + serviceOfferId) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWorkflow(_response));
        });
    }

    protected processGetWorkflow(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    duplicate(id?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/duplicate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicate(_response));
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    getWorkflowInstance(orderId?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/getWorkflowInstance?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetWorkflowInstance(_response));
        });
    }

    protected processGetWorkflowInstance(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    editWorkflow(workflowId?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/editWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditWorkflow(_response));
        });
    }

    protected processEditWorkflow(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    deleteWorkflow(workflowId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/deleteWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteWorkflow(_response));
        });
    }

    protected processDeleteWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveWorkflow(workflowId?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/saveWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveWorkflow(_response));
        });
    }

    protected processSaveWorkflow(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    addModule(workflowId?: string | undefined, moduleName?: string | undefined, isInstance?: boolean | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/addModule?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (moduleName === null)
            throw new Error("The parameter 'moduleName' cannot be null.");
        else if (moduleName !== undefined)
            url_ += "moduleName=" + encodeURIComponent("" + moduleName) + "&";
        if (isInstance === null)
            throw new Error("The parameter 'isInstance' cannot be null.");
        else if (isInstance !== undefined)
            url_ += "isInstance=" + encodeURIComponent("" + isInstance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddModule(_response));
        });
    }

    protected processAddModule(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    removeModule(workflowId?: string | undefined, moduleId?: string | undefined, isInstance?: boolean | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/removeModule?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (moduleId === null)
            throw new Error("The parameter 'moduleId' cannot be null.");
        else if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        if (isInstance === null)
            throw new Error("The parameter 'isInstance' cannot be null.");
        else if (isInstance !== undefined)
            url_ += "isInstance=" + encodeURIComponent("" + isInstance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveModule(_response));
        });
    }

    protected processRemoveModule(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    removeLink(workflowId?: string | undefined, fromModuleId?: string | undefined, toModuleId?: string | undefined, fromName?: string | undefined, toName?: string | undefined, isInstance?: boolean | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/removeLink?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (fromModuleId === null)
            throw new Error("The parameter 'fromModuleId' cannot be null.");
        else if (fromModuleId !== undefined)
            url_ += "fromModuleId=" + encodeURIComponent("" + fromModuleId) + "&";
        if (toModuleId === null)
            throw new Error("The parameter 'toModuleId' cannot be null.");
        else if (toModuleId !== undefined)
            url_ += "toModuleId=" + encodeURIComponent("" + toModuleId) + "&";
        if (fromName === null)
            throw new Error("The parameter 'fromName' cannot be null.");
        else if (fromName !== undefined)
            url_ += "fromName=" + encodeURIComponent("" + fromName) + "&";
        if (toName === null)
            throw new Error("The parameter 'toName' cannot be null.");
        else if (toName !== undefined)
            url_ += "toName=" + encodeURIComponent("" + toName) + "&";
        if (isInstance === null)
            throw new Error("The parameter 'isInstance' cannot be null.");
        else if (isInstance !== undefined)
            url_ += "isInstance=" + encodeURIComponent("" + isInstance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveLink(_response));
        });
    }

    protected processRemoveLink(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    cancelEditWorkflow(workflowId?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/cancelEditWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelEditWorkflow(_response));
        });
    }

    protected processCancelEditWorkflow(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    connectDocks(workflowId?: string | undefined, fromModuleId?: string | undefined, toModuleId?: string | undefined, fromSuccessorName?: string | undefined, isInstance?: boolean | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/connectDocks?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (fromModuleId === null)
            throw new Error("The parameter 'fromModuleId' cannot be null.");
        else if (fromModuleId !== undefined)
            url_ += "fromModuleId=" + encodeURIComponent("" + fromModuleId) + "&";
        if (toModuleId === null)
            throw new Error("The parameter 'toModuleId' cannot be null.");
        else if (toModuleId !== undefined)
            url_ += "toModuleId=" + encodeURIComponent("" + toModuleId) + "&";
        if (fromSuccessorName === null)
            throw new Error("The parameter 'fromSuccessorName' cannot be null.");
        else if (fromSuccessorName !== undefined)
            url_ += "fromSuccessorName=" + encodeURIComponent("" + fromSuccessorName) + "&";
        if (isInstance === null)
            throw new Error("The parameter 'isInstance' cannot be null.");
        else if (isInstance !== undefined)
            url_ += "isInstance=" + encodeURIComponent("" + isInstance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConnectDocks(_response));
        });
    }

    protected processConnectDocks(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    editSettings(id?: string | undefined, moduleId?: string | undefined, propertyName?: string | undefined, isExpression?: boolean | undefined, value?: string | null | undefined, isInstance?: boolean | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/editSettings?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (moduleId === null)
            throw new Error("The parameter 'moduleId' cannot be null.");
        else if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        if (isExpression === null)
            throw new Error("The parameter 'isExpression' cannot be null.");
        else if (isExpression !== undefined)
            url_ += "isExpression=" + encodeURIComponent("" + isExpression) + "&";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (isInstance === null)
            throw new Error("The parameter 'isInstance' cannot be null.");
        else if (isInstance !== undefined)
            url_ += "isInstance=" + encodeURIComponent("" + isInstance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEditSettings(_response));
        });
    }

    protected processEditSettings(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    renameWorkflow(workflowId?: string | undefined, name?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/renameWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRenameWorkflow(_response));
        });
    }

    protected processRenameWorkflow(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    consoleAction(orderId?: string | undefined, moduleId?: string | undefined, actionName?: string | undefined, cancelToken?: CancelToken): Promise<WorkflowDTO> {
        let url_ = this.baseUrl + "/api/admin/consoleAction?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (moduleId === null)
            throw new Error("The parameter 'moduleId' cannot be null.");
        else if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        if (actionName === null)
            throw new Error("The parameter 'actionName' cannot be null.");
        else if (actionName !== undefined)
            url_ += "actionName=" + encodeURIComponent("" + actionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConsoleAction(_response));
        });
    }

    protected processConsoleAction(response: AxiosResponse): Promise<WorkflowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WorkflowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowDTO>(null as any);
    }

    getEnumDictionary( cancelToken?: CancelToken): Promise<{ [key: string]: EnumDictionaryEntry[]; }> {
        let url_ = this.baseUrl + "/api/admin/GetEnumDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnumDictionary(_response));
        });
    }

    protected processGetEnumDictionary(response: AxiosResponse): Promise<{ [key: string]: EnumDictionaryEntry[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: EnumDictionaryEntry[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: EnumDictionaryEntry[]; }>(null as any);
    }

    exportBinaryWorkflow(workflowId?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/exportBinaryWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportBinaryWorkflow(_response));
        });
    }

    protected processExportBinaryWorkflow(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importBinaryWorkflow(fileAttachment?: FileParameter | null | undefined, workflowName?: string | null | undefined, serviceOfferId?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/importBinaryWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileAttachment !== null && fileAttachment !== undefined)
            content_.append("FileAttachment", fileAttachment.data, fileAttachment.fileName ? fileAttachment.fileName : "FileAttachment");
        if (workflowName !== null && workflowName !== undefined)
            content_.append("WorkflowName", workflowName.toString());
        if (serviceOfferId === null || serviceOfferId === undefined)
            throw new Error("The parameter 'serviceOfferId' cannot be null.");
        else
            content_.append("ServiceOfferId", serviceOfferId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportBinaryWorkflow(_response));
        });
    }

    protected processImportBinaryWorkflow(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    manageWorkflow(orderId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/manageWorkflow?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processManageWorkflow(_response));
        });
    }

    protected processManageWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    pauseWorkflow(orderId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/pauseWorkflow?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPauseWorkflow(_response));
        });
    }

    protected processPauseWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignWorkflow(orderId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/assignWorkflow?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignWorkflow(_response));
        });
    }

    protected processAssignWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resumeWorkflow(orderId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/resumeWorkflow?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResumeWorkflow(_response));
        });
    }

    protected processResumeWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resumeFromWorkflow(orderId?: string | undefined, moduleId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/resumeFromWorkflow?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (moduleId === null)
            throw new Error("The parameter 'moduleId' cannot be null.");
        else if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResumeFromWorkflow(_response));
        });
    }

    protected processResumeFromWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AnalyticsClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    menu(id?: string | undefined, cancelToken?: CancelToken): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/charts/menu?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMenu(_response));
        });
    }

    protected processMenu(response: AxiosResponse): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Item[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item[]>(null as any);
    }

    create(analysis: DataAnalysisDTO, cancelToken?: CancelToken): Promise<DataAnalysisDTO> {
        let url_ = this.baseUrl + "/api/charts/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(analysis);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DataAnalysisDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataAnalysisDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataAnalysisDTO>(null as any);
    }

    delete(analyticsId?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/charts/delete?";
        if (analyticsId === null)
            throw new Error("The parameter 'analyticsId' cannot be null.");
        else if (analyticsId !== undefined)
            url_ += "analyticsId=" + encodeURIComponent("" + analyticsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    all( cancelToken?: CancelToken): Promise<DataAnalysisDTO[]> {
        let url_ = this.baseUrl + "/api/charts/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAll(_response));
        });
    }

    protected processAll(response: AxiosResponse): Promise<DataAnalysisDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataAnalysisDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataAnalysisDTO[]>(null as any);
    }

    getMapmarkers(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<MapMarkerDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getMapmarkers?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMapmarkers(_response));
        });
    }

    protected processGetMapmarkers(response: AxiosResponse): Promise<MapMarkerDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MapMarkerDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MapMarkerDTO[]>(null as any);
    }

    getVATVariation(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<TVAVariationDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getVATVariation?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVATVariation(_response));
        });
    }

    protected processGetVATVariation(response: AxiosResponse): Promise<TVAVariationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TVAVariationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TVAVariationDTO[]>(null as any);
    }

    getAvailableTiers(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<TierDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getAvailableTiers?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableTiers(_response));
        });
    }

    protected processGetAvailableTiers(response: AxiosResponse): Promise<TierDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TierDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TierDTO[]>(null as any);
    }

    getBalance(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<BalanceDataDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getBalance?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBalance(_response));
        });
    }

    protected processGetBalance(response: AxiosResponse): Promise<BalanceDataDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BalanceDataDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BalanceDataDTO[]>(null as any);
    }

    getVATAmount(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<VATAmountDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getVATAmount?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVATAmount(_response));
        });
    }

    protected processGetVATAmount(response: AxiosResponse): Promise<VATAmountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<VATAmountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VATAmountDTO[]>(null as any);
    }

    getDelayedPayment(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<DelayedPaymentDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getDelayedPayment?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDelayedPayment(_response));
        });
    }

    protected processGetDelayedPayment(response: AxiosResponse): Promise<DelayedPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DelayedPaymentDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DelayedPaymentDTO[]>(null as any);
    }

    getDeptInterest(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<DeptInterestDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getDeptInterest?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDeptInterest(_response));
        });
    }

    protected processGetDeptInterest(response: AxiosResponse): Promise<DeptInterestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeptInterestDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeptInterestDTO[]>(null as any);
    }

    getCashFlow(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<CashFlowDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getCashFlow?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCashFlow(_response));
        });
    }

    protected processGetCashFlow(response: AxiosResponse): Promise<CashFlowDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CashFlowDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashFlowDTO[]>(null as any);
    }

    getTaxRates(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<TaxRateDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getTaxRates?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaxRates(_response));
        });
    }

    protected processGetTaxRates(response: AxiosResponse): Promise<TaxRateDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaxRateDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxRateDTO[]>(null as any);
    }

    getTaxRatesAno(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<TaxRateThirdPartyDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getTaxRatesAno?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaxRatesAno(_response));
        });
    }

    protected processGetTaxRatesAno(response: AxiosResponse): Promise<TaxRateThirdPartyDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TaxRateThirdPartyDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxRateThirdPartyDTO[]>(null as any);
    }

    getDateStratification(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<DateStratificationDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getDateStratification?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDateStratification(_response));
        });
    }

    protected processGetDateStratification(response: AxiosResponse): Promise<DateStratificationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DateStratificationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateStratificationDTO[]>(null as any);
    }

    dataTable(name?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<DataTable> {
        let url_ = this.baseUrl + "/api/charts/dataTable?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDataTable(_response));
        });
    }

    protected processDataTable(response: AxiosResponse): Promise<DataTable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DataTable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataTable>(null as any);
    }

    rawData(name?: string | undefined, id?: string | undefined, extension?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/charts/rawData?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (extension !== undefined && extension !== null)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRawData(_response));
        });
    }

    protected processRawData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCountriesRules(name?: string | undefined, worksheetName?: string | undefined, id?: string | undefined, cancelToken?: CancelToken): Promise<CountryRuleDTO[]> {
        let url_ = this.baseUrl + "/api/charts/getCountriesRules?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (worksheetName === null)
            throw new Error("The parameter 'worksheetName' cannot be null.");
        else if (worksheetName !== undefined)
            url_ += "worksheetName=" + encodeURIComponent("" + worksheetName) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCountriesRules(_response));
        });
    }

    protected processGetCountriesRules(response: AxiosResponse): Promise<CountryRuleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountryRuleDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryRuleDTO[]>(null as any);
    }

    getColors(id?: string | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/charts/getColors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetColors(_response));
        });
    }

    protected processGetColors(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export class AuthClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/Auth/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BNCClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    sendInvoicesToAccountingService(request: InvoiceIdsRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/SendInvoicesToAccountingService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendInvoicesToAccountingService(_response));
        });
    }

    protected processSendInvoicesToAccountingService(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendInvoicesToEmployees(request: InvoiceIdsRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/SendInvoicesToEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendInvoicesToEmployees(_response));
        });
    }

    protected processSendInvoicesToEmployees(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generateInvoices(request: GenerateInvoicesRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/GenerateInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateInvoices(_response));
        });
    }

    protected processGenerateInvoices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateGeneratedInvoice(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/UpdateGeneratedInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateGeneratedInvoice(_response));
        });
    }

    protected processUpdateGeneratedInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    searchNReplace(request: SearchNReplaceRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/searchNReplace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSearchNReplace(_response));
        });
    }

    protected processSearchNReplace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getInvoices( cancelToken?: CancelToken): Promise<BNCInvoice[]> {
        let url_ = this.baseUrl + "/api/bnc/GetInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoices(_response));
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<BNCInvoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCInvoice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCInvoice[]>(null as any);
    }

    getInvoice(reference?: string | undefined, emplid?: string | undefined, cancelToken?: CancelToken): Promise<BNCInvoice> {
        let url_ = this.baseUrl + "/api/bnc/GetInvoice?";
        if (reference === null)
            throw new Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        if (emplid === null)
            throw new Error("The parameter 'emplid' cannot be null.");
        else if (emplid !== undefined)
            url_ += "emplid=" + encodeURIComponent("" + emplid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoice(_response));
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<BNCInvoice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCInvoice>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCInvoice>(null as any);
    }

    getBNCEmployees(showDisabled?: boolean | undefined, cancelToken?: CancelToken): Promise<BNCEmployee[]> {
        let url_ = this.baseUrl + "/api/bnc/GetBNCEmployees?";
        if (showDisabled === null)
            throw new Error("The parameter 'showDisabled' cannot be null.");
        else if (showDisabled !== undefined)
            url_ += "showDisabled=" + encodeURIComponent("" + showDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBNCEmployees(_response));
        });
    }

    protected processGetBNCEmployees(response: AxiosResponse): Promise<BNCEmployee[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCEmployee[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCEmployee[]>(null as any);
    }

    getBNCEmployee(emplid?: string | undefined, cancelToken?: CancelToken): Promise<BNCEmployee> {
        let url_ = this.baseUrl + "/api/bnc/GetBNCEmployee?";
        if (emplid === null)
            throw new Error("The parameter 'emplid' cannot be null.");
        else if (emplid !== undefined)
            url_ += "emplid=" + encodeURIComponent("" + emplid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBNCEmployee(_response));
        });
    }

    protected processGetBNCEmployee(response: AxiosResponse): Promise<BNCEmployee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCEmployee>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCEmployee>(null as any);
    }

    getBNCEmployeeEvents(emplid?: string | undefined, cancelToken?: CancelToken): Promise<BNCEmployeeEvent[]> {
        let url_ = this.baseUrl + "/api/bnc/GetBNCEmployeeEvents?";
        if (emplid === null)
            throw new Error("The parameter 'emplid' cannot be null.");
        else if (emplid !== undefined)
            url_ += "emplid=" + encodeURIComponent("" + emplid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBNCEmployeeEvents(_response));
        });
    }

    protected processGetBNCEmployeeEvents(response: AxiosResponse): Promise<BNCEmployeeEvent[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCEmployeeEvent[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCEmployeeEvent[]>(null as any);
    }

    getBNCInvoiceEvents(invoiceId?: number | undefined, cancelToken?: CancelToken): Promise<BNCInvoiceEvent[]> {
        let url_ = this.baseUrl + "/api/bnc/GetBNCInvoiceEvents?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBNCInvoiceEvents(_response));
        });
    }

    protected processGetBNCInvoiceEvents(response: AxiosResponse): Promise<BNCInvoiceEvent[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCInvoiceEvent[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCInvoiceEvent[]>(null as any);
    }

    validateInvoices(request: InvoiceIdsRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/ValidateInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateInvoices(_response));
        });
    }

    protected processValidateInvoices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendReport( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/SendReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendReport(_response));
        });
    }

    protected processSendReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getReport(request?: ReportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bnc/GetReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReport(_response));
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getZOption(request: ReportRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bnc/GetZOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetZOption(_response));
        });
    }

    protected processGetZOption(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateEmployeesData(employeesData: EmployeeDataDTO[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/UpdateEmployeesData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeesData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEmployeesData(_response));
        });
    }

    protected processUpdateEmployeesData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateEmployees(employeesData: BNCEmployee[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/UpdateEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeesData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEmployees(_response));
        });
    }

    protected processUpdateEmployees(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInvoices(request: InvoiceIdsRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/DeleteInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInvoices(_response));
        });
    }

    protected processDeleteInvoices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadBNCInvoiceDocument(invoiceId?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bnc/downloadBNCInvoiceDocument?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadBNCInvoiceDocument(_response));
        });
    }

    protected processDownloadBNCInvoiceDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadBNCInvoicePDF(invoiceId?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bnc/downloadBNCInvoicePDF?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadBNCInvoicePDF(_response));
        });
    }

    protected processDownloadBNCInvoicePDF(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadBNCEmployeeData(fileAttachment?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/bnc/uploadBNCEmployeeData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileAttachment !== null && fileAttachment !== undefined)
            content_.append("FileAttachment", fileAttachment.data, fileAttachment.fileName ? fileAttachment.fileName : "FileAttachment");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadBNCEmployeeData(_response));
        });
    }

    protected processUploadBNCEmployeeData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    uploadPOST( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bnc/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadPOST(_response));
        });
    }

    protected processUploadPOST(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadGET(flowChunkNumber?: number | undefined, flowChunkSize?: number | undefined, flowCurrentChunkSize?: number | undefined, flowTotalSize?: number | undefined, flowIdentifier?: string | null | undefined, flowFilename?: string | null | undefined, flowRelativePath?: string | null | undefined, flowTotalChunks?: number | undefined, fileOffset?: number | undefined, requestVerificationToken?: string | null | undefined, blueElephant?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bnc/upload?";
        if (flowChunkNumber === null)
            throw new Error("The parameter 'flowChunkNumber' cannot be null.");
        else if (flowChunkNumber !== undefined)
            url_ += "FlowChunkNumber=" + encodeURIComponent("" + flowChunkNumber) + "&";
        if (flowChunkSize === null)
            throw new Error("The parameter 'flowChunkSize' cannot be null.");
        else if (flowChunkSize !== undefined)
            url_ += "FlowChunkSize=" + encodeURIComponent("" + flowChunkSize) + "&";
        if (flowCurrentChunkSize === null)
            throw new Error("The parameter 'flowCurrentChunkSize' cannot be null.");
        else if (flowCurrentChunkSize !== undefined)
            url_ += "FlowCurrentChunkSize=" + encodeURIComponent("" + flowCurrentChunkSize) + "&";
        if (flowTotalSize === null)
            throw new Error("The parameter 'flowTotalSize' cannot be null.");
        else if (flowTotalSize !== undefined)
            url_ += "FlowTotalSize=" + encodeURIComponent("" + flowTotalSize) + "&";
        if (flowIdentifier !== undefined && flowIdentifier !== null)
            url_ += "FlowIdentifier=" + encodeURIComponent("" + flowIdentifier) + "&";
        if (flowFilename !== undefined && flowFilename !== null)
            url_ += "FlowFilename=" + encodeURIComponent("" + flowFilename) + "&";
        if (flowRelativePath !== undefined && flowRelativePath !== null)
            url_ += "FlowRelativePath=" + encodeURIComponent("" + flowRelativePath) + "&";
        if (flowTotalChunks === null)
            throw new Error("The parameter 'flowTotalChunks' cannot be null.");
        else if (flowTotalChunks !== undefined)
            url_ += "FlowTotalChunks=" + encodeURIComponent("" + flowTotalChunks) + "&";
        if (fileOffset === null)
            throw new Error("The parameter 'fileOffset' cannot be null.");
        else if (fileOffset !== undefined)
            url_ += "FileOffset=" + encodeURIComponent("" + fileOffset) + "&";
        if (requestVerificationToken !== undefined && requestVerificationToken !== null)
            url_ += "RequestVerificationToken=" + encodeURIComponent("" + requestVerificationToken) + "&";
        if (blueElephant === null)
            throw new Error("The parameter 'blueElephant' cannot be null.");
        else if (blueElephant !== undefined)
            url_ += "BlueElephant=" + encodeURIComponent("" + blueElephant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadGET(_response));
        });
    }

    protected processUploadGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    svgInvoice(emplid?: string | undefined, reference?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/bnc/svgInvoice?";
        if (emplid === null)
            throw new Error("The parameter 'emplid' cannot be null.");
        else if (emplid !== undefined)
            url_ += "emplid=" + encodeURIComponent("" + emplid) + "&";
        if (reference === null)
            throw new Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSvgInvoice(_response));
        });
    }

    protected processSvgInvoice(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createOrUpdateBNCEntry(entry: BNCInvoiceEntry, cancelToken?: CancelToken): Promise<BNCInvoiceEntry> {
        let url_ = this.baseUrl + "/api/bnc/createOrUpdateBNCEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entry);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateOrUpdateBNCEntry(_response));
        });
    }

    protected processCreateOrUpdateBNCEntry(response: AxiosResponse): Promise<BNCInvoiceEntry> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BNCInvoiceEntry>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BNCInvoiceEntry>(null as any);
    }

    deleteBNCEntry(entry: BNCInvoiceEntry, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/deleteBNCEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entry);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteBNCEntry(_response));
        });
    }

    protected processDeleteBNCEntry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    reorderBNCInvoiceEntries(entries: { [key: string]: number; }, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/bnc/reorderBNCInvoiceEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entries);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReorderBNCInvoiceEntries(_response));
        });
    }

    protected processReorderBNCInvoiceEntries(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EntityClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id?: string | undefined, cancelToken?: CancelToken): Promise<EntityDTO> {
        let url_ = this.baseUrl + "/api/Entity/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<EntityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityDTO>(null as any);
    }

    all( cancelToken?: CancelToken): Promise<EntityDTO[]> {
        let url_ = this.baseUrl + "/api/Entity/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAll(_response));
        });
    }

    protected processAll(response: AxiosResponse): Promise<EntityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityDTO[]>(null as any);
    }

    add(entity: EntityDTO, cancelToken?: CancelToken): Promise<EntityDTO> {
        let url_ = this.baseUrl + "/api/Entity/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAdd(_response));
        });
    }

    protected processAdd(response: AxiosResponse): Promise<EntityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityDTO>(null as any);
    }

    update(entity: EntityDTO, cancelToken?: CancelToken): Promise<EntityDTO> {
        let url_ = this.baseUrl + "/api/Entity/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EntityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityDTO>(null as any);
    }

    files(fileContainerId?: string | undefined, cancelToken?: CancelToken): Promise<FileDTO[]> {
        let url_ = this.baseUrl + "/api/Entity/files?";
        if (fileContainerId === null)
            throw new Error("The parameter 'fileContainerId' cannot be null.");
        else if (fileContainerId !== undefined)
            url_ += "fileContainerId=" + encodeURIComponent("" + fileContainerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFiles(_response));
        });
    }

    protected processFiles(response: AxiosResponse): Promise<FileDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FileDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDTO[]>(null as any);
    }

    orders( cancelToken?: CancelToken): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/api/Entity/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOrders(_response));
        });
    }

    protected processOrders(response: AxiosResponse): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrderDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDTO[]>(null as any);
    }

    order(id?: string | undefined, cancelToken?: CancelToken): Promise<OrderDTO> {
        let url_ = this.baseUrl + "/api/Entity/order?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOrder(_response));
        });
    }

    protected processOrder(response: AxiosResponse): Promise<OrderDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrderDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDTO>(null as any);
    }

    orderFiles(orderId?: string | undefined, cancelToken?: CancelToken): Promise<FileDTO[]> {
        let url_ = this.baseUrl + "/api/Entity/orderFiles?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOrderFiles(_response));
        });
    }

    protected processOrderFiles(response: AxiosResponse): Promise<FileDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FileDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDTO[]>(null as any);
    }
}

export class FileClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(files: FlowFileUpload[], cancelToken?: CancelToken): Promise<FlowFileUpload[]> {
        let url_ = this.baseUrl + "/api/File/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(files);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FlowFileUpload[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FlowFileUpload[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlowFileUpload[]>(null as any);
    }

    addGET(id?: string | undefined, orderId?: string | undefined, fileContainerId?: string | undefined, flowChunkNumber?: number | undefined, flowChunkSize?: number | undefined, flowCurrentChunkSize?: number | undefined, flowTotalSize?: number | undefined, flowIdentifier?: string | null | undefined, flowFilename?: string | null | undefined, flowRelativePath?: string | null | undefined, flowTotalChunks?: number | undefined, status?: FileStatus | undefined, type?: FileType | undefined, fileSettingId?: string | null | undefined, dataAnalysisId?: string | null | undefined, entityId?: string | null | undefined, itemName?: string | null | undefined, normalizedChunkNumber?: string | null | undefined, normalizedChunkId?: string | null | undefined, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/File/add?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (fileContainerId === null)
            throw new Error("The parameter 'fileContainerId' cannot be null.");
        else if (fileContainerId !== undefined)
            url_ += "FileContainerId=" + encodeURIComponent("" + fileContainerId) + "&";
        if (flowChunkNumber === null)
            throw new Error("The parameter 'flowChunkNumber' cannot be null.");
        else if (flowChunkNumber !== undefined)
            url_ += "FlowChunkNumber=" + encodeURIComponent("" + flowChunkNumber) + "&";
        if (flowChunkSize === null)
            throw new Error("The parameter 'flowChunkSize' cannot be null.");
        else if (flowChunkSize !== undefined)
            url_ += "FlowChunkSize=" + encodeURIComponent("" + flowChunkSize) + "&";
        if (flowCurrentChunkSize === null)
            throw new Error("The parameter 'flowCurrentChunkSize' cannot be null.");
        else if (flowCurrentChunkSize !== undefined)
            url_ += "FlowCurrentChunkSize=" + encodeURIComponent("" + flowCurrentChunkSize) + "&";
        if (flowTotalSize === null)
            throw new Error("The parameter 'flowTotalSize' cannot be null.");
        else if (flowTotalSize !== undefined)
            url_ += "FlowTotalSize=" + encodeURIComponent("" + flowTotalSize) + "&";
        if (flowIdentifier !== undefined && flowIdentifier !== null)
            url_ += "FlowIdentifier=" + encodeURIComponent("" + flowIdentifier) + "&";
        if (flowFilename !== undefined && flowFilename !== null)
            url_ += "FlowFilename=" + encodeURIComponent("" + flowFilename) + "&";
        if (flowRelativePath !== undefined && flowRelativePath !== null)
            url_ += "FlowRelativePath=" + encodeURIComponent("" + flowRelativePath) + "&";
        if (flowTotalChunks === null)
            throw new Error("The parameter 'flowTotalChunks' cannot be null.");
        else if (flowTotalChunks !== undefined)
            url_ += "FlowTotalChunks=" + encodeURIComponent("" + flowTotalChunks) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (fileSettingId !== undefined && fileSettingId !== null)
            url_ += "FileSettingId=" + encodeURIComponent("" + fileSettingId) + "&";
        if (dataAnalysisId !== undefined && dataAnalysisId !== null)
            url_ += "DataAnalysisId=" + encodeURIComponent("" + dataAnalysisId) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (itemName !== undefined && itemName !== null)
            url_ += "ItemName=" + encodeURIComponent("" + itemName) + "&";
        if (normalizedChunkNumber !== undefined && normalizedChunkNumber !== null)
            url_ += "NormalizedChunkNumber=" + encodeURIComponent("" + normalizedChunkNumber) + "&";
        if (normalizedChunkId !== undefined && normalizedChunkId !== null)
            url_ += "NormalizedChunkId=" + encodeURIComponent("" + normalizedChunkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddGET(_response));
        });
    }

    protected processAddGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addPOST(id?: string | undefined, orderId?: string | undefined, fileContainerId?: string | undefined, flowChunkNumber?: number | undefined, flowChunkSize?: number | undefined, flowCurrentChunkSize?: number | undefined, flowTotalSize?: number | undefined, flowIdentifier?: string | null | undefined, flowFilename?: string | null | undefined, flowRelativePath?: string | null | undefined, flowTotalChunks?: number | undefined, file?: FileParameter | null | undefined, status?: string | null | undefined, type?: string | null | undefined, fileSettingId?: string | null | undefined, dataAnalysisId?: string | null | undefined, entityId?: string | null | undefined, itemName?: string | null | undefined, normalizedChunkNumber?: string | null | undefined, normalizedChunkId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/File/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (fileContainerId === null || fileContainerId === undefined)
            throw new Error("The parameter 'fileContainerId' cannot be null.");
        else
            content_.append("FileContainerId", fileContainerId.toString());
        if (flowChunkNumber === null || flowChunkNumber === undefined)
            throw new Error("The parameter 'flowChunkNumber' cannot be null.");
        else
            content_.append("FlowChunkNumber", flowChunkNumber.toString());
        if (flowChunkSize === null || flowChunkSize === undefined)
            throw new Error("The parameter 'flowChunkSize' cannot be null.");
        else
            content_.append("FlowChunkSize", flowChunkSize.toString());
        if (flowCurrentChunkSize === null || flowCurrentChunkSize === undefined)
            throw new Error("The parameter 'flowCurrentChunkSize' cannot be null.");
        else
            content_.append("FlowCurrentChunkSize", flowCurrentChunkSize.toString());
        if (flowTotalSize === null || flowTotalSize === undefined)
            throw new Error("The parameter 'flowTotalSize' cannot be null.");
        else
            content_.append("FlowTotalSize", flowTotalSize.toString());
        if (flowIdentifier !== null && flowIdentifier !== undefined)
            content_.append("FlowIdentifier", flowIdentifier.toString());
        if (flowFilename !== null && flowFilename !== undefined)
            content_.append("FlowFilename", flowFilename.toString());
        if (flowRelativePath !== null && flowRelativePath !== undefined)
            content_.append("FlowRelativePath", flowRelativePath.toString());
        if (flowTotalChunks === null || flowTotalChunks === undefined)
            throw new Error("The parameter 'flowTotalChunks' cannot be null.");
        else
            content_.append("FlowTotalChunks", flowTotalChunks.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (status !== null && status !== undefined)
            content_.append("Status", status.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (fileSettingId !== null && fileSettingId !== undefined)
            content_.append("FileSettingId", fileSettingId.toString());
        if (dataAnalysisId !== null && dataAnalysisId !== undefined)
            content_.append("DataAnalysisId", dataAnalysisId.toString());
        if (entityId !== null && entityId !== undefined)
            content_.append("EntityId", entityId.toString());
        if (itemName !== null && itemName !== undefined)
            content_.append("ItemName", itemName.toString());
        if (normalizedChunkNumber !== null && normalizedChunkNumber !== undefined)
            content_.append("NormalizedChunkNumber", normalizedChunkNumber.toString());
        if (normalizedChunkId !== null && normalizedChunkId !== undefined)
            content_.append("NormalizedChunkId", normalizedChunkId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddPOST(_response));
        });
    }

    protected processAddPOST(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/File/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    chunks(flowFileIdentifier?: string | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: ChunkState; }> {
        let url_ = this.baseUrl + "/api/File/chunks?";
        if (flowFileIdentifier === null)
            throw new Error("The parameter 'flowFileIdentifier' cannot be null.");
        else if (flowFileIdentifier !== undefined)
            url_ += "flowFileIdentifier=" + encodeURIComponent("" + flowFileIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChunks(_response));
        });
    }

    protected processChunks(response: AxiosResponse): Promise<{ [key: string]: ChunkState; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: ChunkState; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: ChunkState; }>(null as any);
    }

    fileProgressState(id?: string | undefined, cancelToken?: CancelToken): Promise<FileProgressState> {
        let url_ = this.baseUrl + "/api/File/FileProgressState?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFileProgressState(_response));
        });
    }

    protected processFileProgressState(response: AxiosResponse): Promise<FileProgressState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FileProgressState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileProgressState>(null as any);
    }

    downloadFile(id?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/File/DownloadFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PortalClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param skipauth (optional) SkipAuth on public endpoints
     * @param recaptchaResponse (optional) recaptcha validation response
     */
    get(skipauth?: boolean | undefined, recaptchaResponse?: string | undefined, cancelToken?: CancelToken): Promise<OfficeDTO[]> {
        let url_ = this.baseUrl + "/api/Portal/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "skipauth": skipauth !== undefined && skipauth !== null ? "" + skipauth : "",
                "recaptchaResponse": recaptchaResponse !== undefined && recaptchaResponse !== null ? "" + recaptchaResponse : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<OfficeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OfficeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfficeDTO[]>(null as any);
    }

    /**
     * @param skipauth (optional) SkipAuth on public endpoints
     * @param recaptchaResponse (optional) recaptcha validation response
     */
    status(skipauth?: boolean | undefined, recaptchaResponse?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Portal/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "skipauth": skipauth !== undefined && skipauth !== null ? "" + skipauth : "",
                "recaptchaResponse": recaptchaResponse !== undefined && recaptchaResponse !== null ? "" + recaptchaResponse : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStatus(_response));
        });
    }

    protected processStatus(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param skipauth (optional) SkipAuth on public endpoints
     * @param recaptchaResponse (optional) recaptcha validation response
     */
    contact(message: ContactMessage, skipauth?: boolean | undefined, recaptchaResponse?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Portal/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "skipauth": skipauth !== undefined && skipauth !== null ? "" + skipauth : "",
                "recaptchaResponse": recaptchaResponse !== undefined && recaptchaResponse !== null ? "" + recaptchaResponse : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processContact(_response));
        });
    }

    protected processContact(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param skipauth (optional) SkipAuth on public endpoints
     * @param recaptchaResponse (optional) recaptcha validation response
     */
    cspreport(cspReportRequest: CspReportRequest, skipauth?: boolean | undefined, recaptchaResponse?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Portal/cspreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cspReportRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "skipauth": skipauth !== undefined && skipauth !== null ? "" + skipauth : "",
                "recaptchaResponse": recaptchaResponse !== undefined && recaptchaResponse !== null ? "" + recaptchaResponse : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCspreport(_response));
        });
    }

    protected processCspreport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PTwoClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    uploadScope(mainEntityId?: string | null | undefined, scopeWorksheetName?: string | null | undefined, p2WorksheetName?: string | null | undefined, hGName?: string | null | undefined, p2FileAttachment?: FileParameter | null | undefined, scopeFileAttachment?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<ModelContextDTO> {
        let url_ = this.baseUrl + "/api/ptwo/uploadScope";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (mainEntityId !== null && mainEntityId !== undefined)
            content_.append("MainEntityId", mainEntityId.toString());
        if (scopeWorksheetName !== null && scopeWorksheetName !== undefined)
            content_.append("ScopeWorksheetName", scopeWorksheetName.toString());
        if (p2WorksheetName !== null && p2WorksheetName !== undefined)
            content_.append("P2WorksheetName", p2WorksheetName.toString());
        if (hGName !== null && hGName !== undefined)
            content_.append("HGName", hGName.toString());
        if (p2FileAttachment !== null && p2FileAttachment !== undefined)
            content_.append("P2FileAttachment", p2FileAttachment.data, p2FileAttachment.fileName ? p2FileAttachment.fileName : "P2FileAttachment");
        if (scopeFileAttachment !== null && scopeFileAttachment !== undefined)
            content_.append("ScopeFileAttachment", scopeFileAttachment.data, scopeFileAttachment.fileName ? scopeFileAttachment.fileName : "ScopeFileAttachment");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadScope(_response));
        });
    }

    protected processUploadScope(response: AxiosResponse): Promise<ModelContextDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ModelContextDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelContextDTO>(null as any);
    }
}

export class ServiceOfferClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getByRef(tajReference?: string | null | undefined, serviceOfferCode?: string | null | undefined, cancelToken?: CancelToken): Promise<OrderDTO> {
        let url_ = this.baseUrl + "/api/ServiceOffer/getByRef?";
        if (tajReference !== undefined && tajReference !== null)
            url_ += "tajReference=" + encodeURIComponent("" + tajReference) + "&";
        if (serviceOfferCode !== undefined && serviceOfferCode !== null)
            url_ += "serviceOfferCode=" + encodeURIComponent("" + serviceOfferCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByRef(_response));
        });
    }

    protected processGetByRef(response: AxiosResponse): Promise<OrderDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrderDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDTO>(null as any);
    }

    ordersettings(orderSettings: OrderSettingDTO[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ServiceOffer/ordersettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderSettings);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processOrdersettings(_response));
        });
    }

    protected processOrdersettings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateOrder(order: OrderDTO, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ServiceOffer/updateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateOrder(_response));
        });
    }

    protected processUpdateOrder(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    finalizeOrder(order: OrderDTO, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ServiceOffer/finalizeOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFinalizeOrder(_response));
        });
    }

    protected processFinalizeOrder(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param skipauth (optional) SkipAuth on public endpoints
     * @param recaptchaResponse (optional) recaptcha validation response
     */
    serviceOffers(skipauth?: boolean | undefined, recaptchaResponse?: string | undefined, cancelToken?: CancelToken): Promise<ServiceOfferDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceOffer/serviceOffers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "skipauth": skipauth !== undefined && skipauth !== null ? "" + skipauth : "",
                "recaptchaResponse": recaptchaResponse !== undefined && recaptchaResponse !== null ? "" + recaptchaResponse : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processServiceOffers(_response));
        });
    }

    protected processServiceOffers(response: AxiosResponse): Promise<ServiceOfferDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ServiceOfferDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOfferDTO[]>(null as any);
    }
}

export class TRexClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param skipauth (optional) SkipAuth on public endpoints
     * @param recaptchaResponse (optional) recaptcha validation response
     * @param token (optional) 
     * @param action (optional) 
     */
    validation(skipauth?: boolean | undefined, recaptchaResponse?: string | undefined, token?: string | null | undefined, action?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TRex/validation?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (action !== undefined && action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "skipauth": skipauth !== undefined && skipauth !== null ? "" + skipauth : "",
                "recaptchaResponse": recaptchaResponse !== undefined && recaptchaResponse !== null ? "" + recaptchaResponse : "",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidation(_response));
        });
    }

    protected processValidation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface DataAnalysisDTO {
    id?: string;
    orderId?: string | undefined;
    entityId?: string;
    fileContainerId?: string;
    fiscalYear?: number;
    title?: string | undefined;
    subtitle?: string | undefined;
    creationDate?: Date;
}

export interface ServiceOfferDTO {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    photoB64?: string | undefined;
    translation?: TranslationDTO | undefined;
    settings?: SettingDTO[] | undefined;
    serviceOfferLevels?: ServiceOfferLevelDTO[] | undefined;
    childServiceOffers?: ServiceOfferDTO[] | undefined;
}

export interface TranslationDTO {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface SettingDTO {
    id?: string;
    code?: string | undefined;
    pattern?: string | undefined;
    sortValue?: number;
    settingTypeId?: number;
    selectionTypeOption?: string | undefined;
    settingType?: SettingType | undefined;
    serviceOfferId?: string;
    translations?: TranslationDTO[] | undefined;
    isFileSetting?: boolean;
    fileSettingId?: string;
    fileSetting?: FileSettingDTO | undefined;
}

export interface SettingType {
    id?: number;
    name: string;
    description?: string | undefined;
    settings?: Setting[] | undefined;
}

export interface Setting {
    id?: string;
    code?: string | undefined;
    pattern?: string | undefined;
    sortValue?: number;
    settingTypeId?: number;
    selectionTypeOption?: string | undefined;
    isFileSetting?: boolean;
    translationId?: string;
    settingType?: SettingType | undefined;
    serviceOfferId?: string;
    serviceOffer?: ServiceOffer | undefined;
    translations?: Translation[] | undefined;
    fileSettingId?: string | undefined;
    fileSetting?: FileSetting | undefined;
}

export interface ServiceOffer {
    id?: string;
    code: string;
    name: string;
    description: string;
    isActive?: boolean;
    photoB64?: string | undefined;
    translations?: Translation[] | undefined;
    settings?: Setting[] | undefined;
    workflows?: Workflow[] | undefined;
    serviceOfferLevels?: ServiceOfferLevel[] | undefined;
    parentServiceOfferId?: string | undefined;
    parentServiceOffer?: ServiceOffer | undefined;
    childServiceOffers?: ServiceOffer[] | undefined;
}

export interface Translation {
    id?: string;
    languageId?: string;
    name?: string | undefined;
    description?: string | undefined;
    language?: Language | undefined;
}

export interface Language {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    sortValue?: number;
}

export interface Workflow {
    id?: string;
    name?: string | undefined;
    sortValue?: number;
    definition?: string | undefined;
    binaryDefinition?: string | undefined;
    editedBinaryDefinition?: string | undefined;
    editorId?: string | undefined;
    serviceOfferId?: string;
    serviceOffer?: ServiceOffer | undefined;
    orders?: Order[] | undefined;
    editor?: TaxAnalyticsUser | undefined;
}

export interface Order {
    id?: string;
    businessFlowId?: string;
    subscriptionId?: string | undefined;
    creatorId?: string | undefined;
    languageId?: string;
    serviceOfferId?: string;
    workflowId?: string | undefined;
    entityId?: string | undefined;
    creationDate?: Date;
    lastEventDate?: Date;
    status?: OrderStatus;
    statusLabel?: string | undefined;
    tajReference?: string | undefined;
    orderNo?: number;
    serviceOfferLevelId?: string | undefined;
    projectPath?: string | undefined;
    rowVersion?: string | undefined;
    workflowInstanceId?: string | undefined;
    workflowInstance?: WorkflowInstance | undefined;
    serviceOffer?: ServiceOffer | undefined;
    serviceOfferLevel?: ServiceOfferLevel | undefined;
    creator?: TaxAnalyticsUser | undefined;
    businessFlow?: BusinessFlow | undefined;
    language?: Language | undefined;
    orderInputFiles?: File[] | undefined;
    orderResultFiles?: File[] | undefined;
    subscription?: Subscription | undefined;
    workflow?: Workflow | undefined;
    entity?: Entity | undefined;
    analysis?: DataAnalysis[] | undefined;
    orderSettings?: OrderSetting[] | undefined;
    sharedOrders?: SharedOrder[] | undefined;
    logs?: Log[] | undefined;
    files?: File[] | undefined;
}

export enum OrderStatus {
    Initialization = 1,
    UploadPending = 5,
    RunPending = 10,
    Running = 20,
    Paused = 30,
    ActionPending = 40,
    Terminated = 50,
    Archived = 60,
    Edition = 70,
    Error = -1,
}

export interface WorkflowInstance {
    id?: string;
    orderId?: string;
    workflowData?: string | undefined;
    workflow?: Workflow | undefined;
    order?: Order | undefined;
}

export interface ServiceOfferLevel {
    id?: string;
    code: string;
    name: string;
    subtitle?: string | undefined;
    translations?: Translation[] | undefined;
    serviceOfferId?: string;
    serviceOffer?: ServiceOffer | undefined;
    serviceOfferLevelSettings?: ServiceOfferLevelSetting[] | undefined;
}

export interface ServiceOfferLevelSetting {
    serviceOfferLevelId?: string;
    serviceOfferLevel?: ServiceOfferLevel | undefined;
    settingId?: string;
    setting?: Setting | undefined;
    isOptional?: boolean;
}

export interface TaxAnalyticsUser {
    email?: string | undefined;
    userName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    id?: string;
    nameIdentifier?: string | undefined;
    logoPath?: string | undefined;
    role?: UserRole;
    logo?: string | undefined;
    isAdmin?: boolean;
    isHR?: boolean;
    isSuperAdmin?: boolean;
    entities?: Entity[] | undefined;
    orders?: Order[] | undefined;
    sharedOrders?: SharedOrder[] | undefined;
    userBusinessFlows?: UserBusinessFlow[] | undefined;
    features?: Feature[] | undefined;
}

export enum UserRole {
    Client = 0,
    Manager = 1,
    HR = 2,
    Admin = 3,
    SuperAdmin = 4,
}

export interface Entity {
    id?: string;
    parentId?: string | undefined;
    parent?: Entity | undefined;
    children?: Entity[] | undefined;
    name?: string | undefined;
    isActive?: boolean;
    creatorId?: string;
    fileContainerId?: string;
    type?: EntityType;
    logoPath?: string | undefined;
    creator?: TaxAnalyticsUser | undefined;
    logo?: string | undefined;
    fileContainer?: FileContainer | undefined;
    rights?: EntityRights[] | undefined;
    orders?: Order[] | undefined;
    analysis?: DataAnalysis[] | undefined;
}

export enum EntityType {
    Company = 0,
    Entity = 1,
}

export interface FileContainer {
    id?: string;
    files?: File[] | undefined;
    parentId?: string;
}

export interface File {
    id?: string;
    fileContainerId?: string;
    path?: string | undefined;
    hash?: string | undefined;
    type?: FileType;
    name?: string | undefined;
    extension?: string | undefined;
    size?: number;
    creationDate?: Date;
    status?: FileStatus;
    fileContainer?: FileContainer | undefined;
    orderId?: string | undefined;
    fileSettingId?: string | undefined;
    order?: Order | undefined;
    dataAnalysisId?: string | undefined;
    dataAnalysis?: DataAnalysis | undefined;
}

export enum FileType {
    Input = 0,
    Result = 1,
    Work = 2,
    Analytics = 3,
}

export enum FileStatus {
    Added = 0,
    Uploading = 1,
    Paused = 2,
    Uploaded = 3,
    Merging = 4,
    Completed = 5,
}

export interface DataAnalysis {
    id?: string;
    fiscalYear?: number;
    analysisWorkspacePath?: string | undefined;
    entityId?: string;
    entity?: Entity | undefined;
    orderId?: string | undefined;
    order?: Order | undefined;
    isAvailable?: boolean;
    title?: string | undefined;
    subtitle?: string | undefined;
    creationDate?: Date;
    files?: File[] | undefined;
}

export interface EntityRights {
    entityId?: string;
    taxAnalyticsUserId?: string;
    entity?: Entity | undefined;
    user?: TaxAnalyticsUser | undefined;
    rights?: Rights;
}

export enum Rights {
    None = 0,
    Read = 1,
    Write = 2,
    Owner = 3,
    Admin = 8,
}

export interface SharedOrder {
    taxAnalyticsUserId?: string;
    taxAnalyticsUser?: TaxAnalyticsUser | undefined;
    orderId?: string;
    order?: Order | undefined;
}

export interface UserBusinessFlow {
    taxAnalyticsUserId?: string;
    taxAnalyticsUser?: TaxAnalyticsUser | undefined;
    businessFlowId?: string;
    businessFlow?: BusinessFlow | undefined;
}

export interface BusinessFlow {
    id?: string;
    languageId?: string;
    name?: string | undefined;
    activationDate?: Date;
    expirationDate?: Date | undefined;
    rootPath?: string | undefined;
    language?: Language | undefined;
    orders?: Order[] | undefined;
    userBusinessFlows?: UserBusinessFlow[] | undefined;
}

export interface Feature {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
}

export interface Subscription {
    id?: string;
    languageId?: string;
    language?: Language | undefined;
    name?: string | undefined;
    activatioDate?: Date;
    expirationDate?: Date;
    managerEmail?: string | undefined;
}

export interface OrderSetting {
    id?: string;
    orderId?: string;
    settingId?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;
    order?: Order | undefined;
    setting?: Setting | undefined;
}

export interface Log {
    id?: string;
    creationDate?: Date;
    logLevel?: number;
    message?: string | undefined;
    hostName?: string | undefined;
    layer?: string | undefined;
    processName?: string | undefined;
    userName?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;
    itemId?: string | undefined;
    itemPath?: string | undefined;
    errorType?: string | undefined;
    errorSource?: string | undefined;
    errorMessage?: string | undefined;
    errorTarget?: string | undefined;
    duration?: string;
}

export interface FileSetting {
    id?: string;
    settingId?: string | undefined;
    code?: string | undefined;
    pattern?: string | undefined;
    suffix?: string | undefined;
    setting?: Setting | undefined;
}

export interface FileSettingDTO {
    id?: string;
    settingId?: string | undefined;
    code?: string | undefined;
    pattern?: string | undefined;
    suffix?: string | undefined;
}

export interface ServiceOfferLevelDTO {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    subtitle?: string | undefined;
    serviceOfferLevelSettings?: ServiceOfferLevelSettingDTO[] | undefined;
    files?: FileSettingDTO[] | undefined;
    translation?: TranslationDTO | undefined;
}

export interface ServiceOfferLevelSettingDTO {
    serviceOfferLevelId?: string;
    settingId?: string;
    setting?: SettingDTO | undefined;
    isOptional?: boolean;
}

export interface OrderDTO {
    id?: string;
    creatorId?: string;
    entityId?: string | undefined;
    serviceOfferId?: string;
    serviceOfferLevelId?: string | undefined;
    creationDate?: Date;
    lastEventDate?: Date;
    status?: OrderStatus;
    statusLabel?: string | undefined;
    statusName?: string | undefined;
    tajReference?: string | undefined;
    orderInputFiles?: FileDTO[] | undefined;
    orderResultFiles?: FileDTO[] | undefined;
    orderFileSettings?: OrderSettingDTO[] | undefined;
    orderInputSettings?: OrderSettingDTO[] | undefined;
    serviceOffer?: ServiceOfferDTO | undefined;
    serviceOfferLevel?: ServiceOfferLevelDTO | undefined;
    creatorName?: string | undefined;
    entityName?: string | undefined;
    label?: string | undefined;
    hasWorkflow?: boolean;
}

export interface FileDTO {
    id?: string;
    fileContainerId?: string;
    path?: string | undefined;
    hash?: string | undefined;
    type?: FileType;
    name?: string | undefined;
    extension?: string | undefined;
    size?: number;
    creationDate?: Date;
    status?: FileStatus;
    progress?: number;
    uniqueIdentifier?: string | undefined;
    isUploading?: boolean;
    paused?: boolean;
    averageSpeed?: number;
    currentSpeed?: number;
    error?: boolean;
    relativePath?: string | undefined;
    orderId?: string;
    fileSettingId?: string;
    dataAnalysisId?: string;
}

export interface OrderSettingDTO {
    id?: string;
    orderId?: string;
    settingId?: string;
    setting?: SettingDTO | undefined;
    code?: string | undefined;
    value?: string | undefined;
}

export interface FlowFileUpload {
    id?: string;
    orderId?: string;
    fileContainerId?: string;
    flowChunkNumber?: number;
    flowChunkSize?: number;
    flowCurrentChunkSize?: number;
    flowTotalSize?: number;
    flowIdentifier?: string | undefined;
    flowFilename?: string | undefined;
    flowRelativePath?: string | undefined;
    flowTotalChunks?: number;
    file?: string | undefined;
    status?: FileStatus;
    type?: FileType;
    fileSettingId?: string | undefined;
    dataAnalysisId?: string | undefined;
    entityId?: string | undefined;
    itemName?: string | undefined;
    normalizedChunkNumber?: string | undefined;
    normalizedChunkId?: string | undefined;
}

export enum ChunkState {
    Init = 0,
    Uploaded = 1,
    Merged = 2,
}

export interface EntityAdminDTO {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    creatorId?: string;
    creatorName?: string | undefined;
    fileContainerId?: string;
    type?: EntityType;
    logoPath?: string | undefined;
    logo?: string | undefined;
    parentId?: string;
    children?: EntityAdminDTO[] | undefined;
    rights?: EntityRightsDTO[] | undefined;
}

export interface EntityRightsDTO {
    taxAnalyticsUserId?: string;
    rights?: Rights;
}

export interface UserDTO {
    email?: string | undefined;
    userName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    id?: string;
    logoPath?: string | undefined;
    logo?: string | undefined;
    role?: UserRole;
    isAdmin?: boolean;
    isHR?: boolean;
    features?: Feature[] | undefined;
    configuration?: { [key: string]: string; } | undefined;
}

export interface UserRoleRequestDTO {
    id?: string;
    role?: UserRole;
}

export interface WorkflowModuleDefinition {
    isPortalAction?: boolean;
    moduleName?: string | undefined;
    moduleCategory?: WorkflowModuleCategory;
    designModuleName?: string | undefined;
    designModuleDescription?: string | undefined;
    maximumParallelRunning?: number;
    blockOnError?: boolean;
}

export enum WorkflowModuleCategory {
    EntryPoint = 1,
    Condition = 2,
    ServerAction = 3,
    ConsoleAction = 4,
    PortalAction = 5,
    RobotAction = 6,
}

export interface WorkflowDTO {
    id?: string;
    name?: string;
    workflowInstance?: WorkflowInstanceViewModel;
    connections?: WorkflowModuleConnectionDTO[];
    editorId?: string;
    isEdition?: boolean;
}

export interface WorkflowSettingsContainerBaseOfWorkflowInstanceViewModel {
    changed?: boolean;
    settingsSource?: any;
    designSettings?: WorkflowSettingViewModelOfWorkflowInstanceViewModel[];
    isValid?: boolean;
    validationErrorMessage?: string;
    areSettingsValid?: boolean;
    settingsErrorMessage?: string;
    settingErrors?: WorkflowSettingViewModelOfWorkflowInstanceViewModel[];
}

export interface WorkflowInstanceViewModel extends WorkflowSettingsContainerBaseOfWorkflowInstanceViewModel {
    allDocks?: any[][];
    allConnections?: IWorkflowModuleConnection[];
    entryPoint?: IWorkflowModule;
    runningModules?: IWorkflowModule[];
    pendingModules?: IWorkflowModule[];
    runningConsoleActions?: WorkflowPendingActionSettingsPartBase[];
    context?: WorkflowContext;
    settingsSource?: any;
    name?: WorkflowSettingOfString;
    status?: WorkflowSettingOfWorkflowInstanceStatus;
    isEditable?: boolean;
    isDefinition?: boolean;
    selectedModule?: WorkflowModuleViewModel;
    allModules?: IWorkflowModule[];
    errorModules?: WorkflowModuleViewModel[];
    areModulesValid?: boolean;
    modulesErrorMessage?: string;
}

export interface IWorkflowModuleConnection {
    from?: any[] | undefined;
    to?: any[] | undefined;
}

export interface IWorkflowModule {
    workflowInstance?: IWorkflowInstance | undefined;
    settings?: IWorkflowSettingsPart | undefined;
    predecessors?: any[] | undefined;
    successorsList?: { [key: string]: any[]; } | undefined;
}

export interface IWorkflowInstance {
    name?: WorkflowSettingOfString | undefined;
    status?: WorkflowSettingOfWorkflowInstanceStatus | undefined;
    context?: WorkflowContext | undefined;
    allModules?: IWorkflowModule[] | undefined;
    allDocks?: any[][] | undefined;
    allConnections?: IWorkflowModuleConnection[] | undefined;
    entryPoint?: IWorkflowModule | undefined;
    runningModules?: IWorkflowModule[] | undefined;
    pendingModules?: IWorkflowModule[] | undefined;
    runningConsoleActions?: WorkflowPendingActionSettingsPartBase[] | undefined;
}

export interface WorkflowSettingOfString {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: string | undefined;
    value?: string | undefined;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfWorkflowInstanceStatus {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: WorkflowInstanceStatus;
    value?: WorkflowInstanceStatus;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export enum WorkflowInstanceStatus {
    Definition = 0,
    Running = 1,
    Paused = 2,
    Error = 3,
    Terminated = 4,
    Pending = 5,
}

export interface WorkflowContext {
    serviceOffer?: ServiceOffer | undefined;
    date?: Date;
    mois?: string | undefined;
    fluxAffaire?: BusinessFlow | undefined;
    abonnement?: Subscription | undefined;
    createur?: TaxAnalyticsUser | undefined;
    commande?: Order | undefined;
    inputFiles?: string | undefined;
    resultFiles?: string | undefined;
    workflow?: IWorkflowInstance | undefined;
    updateStatusMethod?: UpdateStatusHandler | undefined;
}

export interface Delegate {
    target?: any | undefined;
    method?: MethodInfo;
}

export interface MulticastDelegate extends Delegate {
}

export interface UpdateStatusHandler extends MulticastDelegate {
}

export interface MemberInfo {
    memberType?: MemberTypes;
    name?: string;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module?: Module;
    customAttributes?: CustomAttributeData[];
    isCollectible?: boolean;
    metadataToken?: number;
}

export interface MethodBase extends MemberInfo {
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

export interface MethodInfo extends MethodBase {
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: string;
    returnTypeCustomAttributes?: ICustomAttributeProvider;
    genericParameterCount?: number;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export interface ParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: string;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export interface Module {
    assembly?: Assembly;
    fullyQualifiedName?: string;
    name?: string;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;
}

export interface Assembly {
    definedTypes?: TypeInfo[];
    exportedTypes?: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string;
    isDynamic?: boolean;
    location?: string;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[];
    escapedCodeBase?: string;
    manifestModule?: Module;
    modules?: Module[];
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export interface Anonymous {
    genericTypeParameters?: string[];
    declaredConstructors?: ConstructorInfo[];
    declaredEvents?: EventInfo[];
    declaredFields?: FieldInfo[];
    declaredMembers?: MemberInfo[];
    declaredMethods?: MethodInfo[];
    declaredNestedTypes?: TypeInfo[];
    declaredProperties?: PropertyInfo[];
    implementedInterfaces?: string[];
}

export interface TypeInfo extends Anonymous {

    [key: string]: any;
}

export interface ConstructorInfo extends MethodBase {
    memberType?: MemberTypes;
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    MemberAccessMask = 7,
    UnmanagedExport = 8,
    Static = 16,
    Final = 32,
    Virtual = 64,
    HideBySig = 128,
    NewSlot = 256,
    VtableLayoutMask = 256,
    CheckAccessOnOverride = 512,
    Abstract = 1024,
    SpecialName = 2048,
    RTSpecialName = 4096,
    PinvokeImpl = 8192,
    HasSecurity = 16384,
    RequireSecObject = 32768,
    ReservedMask = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export interface RuntimeMethodHandle {
    value?: IntPtr;
}

export interface IntPtr {
}

export interface EventInfo extends MemberInfo {
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    isSpecialName?: boolean;
    addMethod?: MethodInfo | undefined;
    removeMethod?: MethodInfo | undefined;
    raiseMethod?: MethodInfo | undefined;
    isMulticast?: boolean;
    eventHandlerType?: string | undefined;
}

export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    ReservedMask = 1024,
}

export interface FieldInfo extends MemberInfo {
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: string;
    isInitOnly?: boolean;
    isLiteral?: boolean;
    isNotSerialized?: boolean;
    isPinvokeImpl?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;
}

export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export interface RuntimeFieldHandle {
    value?: IntPtr;
}

export interface PropertyInfo extends MemberInfo {
    memberType?: MemberTypes;
    propertyType?: string;
    attributes?: PropertyAttributes;
    isSpecialName?: boolean;
    canRead?: boolean;
    canWrite?: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;
}

export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export interface CustomAttributeData {
    attributeType?: string;
    constructor?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[];
    namedArguments?: CustomAttributeNamedArgument[];
}

export interface CustomAttributeTypedArgument {
    argumentType?: string;
    value?: any | undefined;
}

export interface CustomAttributeNamedArgument {
    argumentType?: string;
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string;
    isField?: boolean;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export interface ModuleHandle {
    mdStreamVersion?: number;
}

export interface ICustomAttributeProvider {
}

export interface WorkflowPartBaseOfWorkflowSettingsPartExport {
    isRootMetadata?: boolean;
    type?: string | undefined;
    name?: string | undefined;
    syncRoot?: any | undefined;
    metadata?: WorkflowSettingsPartExport | undefined;
    moduleName?: WorkflowSettingOfString | undefined;
}

export interface WorkflowSettingsPartBase extends WorkflowPartBaseOfWorkflowSettingsPartExport {
    designModuleName?: WorkflowSettingOfString | undefined;
    designModuleDescription?: WorkflowSettingOfString | undefined;
    moduleCategory?: WorkflowSettingOfWorkflowModuleCategory | undefined;
    maximumParallelRunning?: WorkflowSettingOfInteger | undefined;
    blockOnError?: WorkflowSettingOfBoolean | undefined;
    id?: WorkflowSettingOfGuid | undefined;
    designName?: WorkflowSettingOfString | undefined;
    designPositionX?: WorkflowSettingOfInteger | undefined;
    designPositionY?: WorkflowSettingOfInteger | undefined;
    orderSettings?: WorkflowSettingOfDictionaryOfStringAndString | undefined;
    actionServer?: WorkflowSettingOfString | undefined;
    start?: WorkflowSettingOfNullableDateTime | undefined;
    lastEvent?: WorkflowSettingOfNullableDateTime | undefined;
    end?: WorkflowSettingOfNullableDateTime | undefined;
    status?: WorkflowSettingOfWorkflowModuleStatus | undefined;
    result?: WorkflowSettingOfString | undefined;
    selectedSuccessorName?: WorkflowSettingOfString | undefined;
    worker?: IWorkflowWorkerPart | undefined;
}

export interface WorkflowPendingActionSettingsPartBase extends WorkflowSettingsPartBase {
    managers?: WorkflowSettingOfString | undefined;
}

export interface WorkflowSettingOfWorkflowModuleCategory {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: WorkflowModuleCategory;
    value?: WorkflowModuleCategory;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfInteger {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: number;
    value?: number;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfBoolean {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: boolean;
    value?: boolean;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfGuid {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: string;
    value?: string;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfDictionaryOfStringAndString {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: { [key: string]: string; } | undefined;
    value?: { [key: string]: string; } | undefined;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfNullableDateTime {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: Date | undefined;
    value?: Date | undefined;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export interface WorkflowSettingOfWorkflowModuleStatus {
    designDescription?: string | undefined;
    isEditable?: boolean;
    designName?: string | undefined;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    directValue?: WorkflowModuleStatus;
    value?: WorkflowModuleStatus;
    objectValue?: any | undefined;
    objectDirectValue?: any | undefined;
    isVisible?: boolean;
}

export enum WorkflowModuleStatus {
    None = 0,
    Launching = 1,
    Running = 2,
    ActionPending = 3,
    Paused = 4,
    Success = 5,
    Error = 6,
}

export interface IWorkflowWorkerPart {
}

export interface Attribute {
    typeId?: any;
}

export interface ExportAttribute extends Attribute {
    isRootMetadata?: boolean;
    type?: string | undefined;
    name?: string | undefined;
}

export interface WorkflowExportPartBase extends ExportAttribute {
    isPortalAction?: boolean;
    moduleName?: string | undefined;
}

export interface WorkflowSettingsPartExport extends WorkflowExportPartBase {
    designModuleName?: string | undefined;
    designModuleDescription?: string | undefined;
    moduleCategory?: WorkflowModuleCategory;
    maximumParallelRunning?: number;
    blockOnError?: boolean;
}

export interface IWorkflowSettingsPart {
    designModuleName?: WorkflowSettingOfString | undefined;
    designModuleDescription?: WorkflowSettingOfString | undefined;
    moduleCategory?: WorkflowSettingOfWorkflowModuleCategory | undefined;
    maximumParallelRunning?: WorkflowSettingOfInteger | undefined;
    blockOnError?: WorkflowSettingOfBoolean | undefined;
    id?: WorkflowSettingOfGuid | undefined;
    designName?: WorkflowSettingOfString | undefined;
    designPositionX?: WorkflowSettingOfInteger | undefined;
    designPositionY?: WorkflowSettingOfInteger | undefined;
    status?: WorkflowSettingOfWorkflowModuleStatus | undefined;
    orderSettings?: WorkflowSettingOfDictionaryOfStringAndString | undefined;
    actionServer?: WorkflowSettingOfString | undefined;
    start?: WorkflowSettingOfNullableDateTime | undefined;
    lastEvent?: WorkflowSettingOfNullableDateTime | undefined;
    end?: WorkflowSettingOfNullableDateTime | undefined;
    result?: WorkflowSettingOfString | undefined;
    selectedSuccessorName?: WorkflowSettingOfString | undefined;
    worker?: IWorkflowWorkerPart | undefined;
}

export interface WorkflowSettingsContainerBaseOfWorkflowModuleViewModel {
    changed?: boolean;
    settingsSource?: any;
    designSettings?: WorkflowSettingViewModelOfWorkflowModuleViewModel[];
    isValid?: boolean;
    validationErrorMessage?: string;
    areSettingsValid?: boolean;
    settingsErrorMessage?: string;
    settingErrors?: WorkflowSettingViewModelOfWorkflowModuleViewModel[];
}

export interface WorkflowModuleViewModel extends WorkflowSettingsContainerBaseOfWorkflowModuleViewModel {
    workflowInstance?: IWorkflowInstance;
    settings?: IWorkflowSettingsPart;
    predecessors?: any[];
    successorsList?: { [key: string]: any[]; };
    settingsSource?: any;
    designName?: string;
    designModuleDescription?: string;
    isSelected?: boolean;
    positionX?: number;
    positionY?: number;
    areDocksValid?: boolean;
    docksErrorMessage?: string;
}

export interface WorkflowSettingViewModelOfWorkflowModuleViewModel {
    changed?: boolean;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string;
    directValue?: any;
    value?: any;
    isVisible?: boolean;
    readOnlyDefinition?: string;
    readOnlyInstance?: string;
    propertyName?: string;
    workflowSetting?: IWorkflowSetting;
    isComputable?: boolean;
    isComplex?: boolean;
    enumValues?: IEnumerable;
    designName?: string;
    designDescription?: string;
    expectedType?: string;
    isEditable?: boolean;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    isValid?: boolean;
    validationMessage?: string;
    suggestions?: Suggestion[];
}

export interface IWorkflowSetting {
    expectedType?: string | undefined;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string | undefined;
    objectDirectValue?: any | undefined;
    objectValue?: any | undefined;
    isVisible?: boolean;
}

export interface IEnumerable {
}

export interface Suggestion {
    start?: number;
    length?: number;
    possibilities?: string[] | undefined;
}

export interface WorkflowSettingViewModelOfWorkflowInstanceViewModel {
    changed?: boolean;
    hasValue?: boolean;
    isExpression?: boolean;
    expression?: string;
    directValue?: any;
    value?: any;
    isVisible?: boolean;
    readOnlyDefinition?: string;
    readOnlyInstance?: string;
    propertyName?: string;
    workflowSetting?: IWorkflowSetting;
    isComputable?: boolean;
    isComplex?: boolean;
    enumValues?: IEnumerable;
    designName?: string;
    designDescription?: string;
    expectedType?: string;
    isEditable?: boolean;
    displayOrder?: number;
    isMandatory?: boolean;
    requiresEditPanel?: boolean;
    isValid?: boolean;
    validationMessage?: string;
    suggestions?: Suggestion[];
}

export interface WorkflowModuleConnectionDTO {
    from?: WorkflowModuleDockDTO;
    to?: WorkflowModuleDockDTO;
}

export interface WorkflowModuleDockDTO {
    name?: string;
    direction?: WorkflowModuleDockDirection;
    moduleId?: string;
    connections?: WorkflowModuleConnectionDTO[];
}

export enum WorkflowModuleDockDirection {
    Input = 1,
    Output = 2,
}

export interface EnumDictionaryEntry {
    value?: any | undefined;
    key?: string | undefined;
    description?: string | undefined;
    namespace?: string | undefined;
}

export interface Item {
    id?: string | undefined;
    primary?: string | undefined;
    secondary?: string | undefined;
    children?: Item[] | undefined;
    downloadFileName?: string | undefined;
    extension?: string | undefined;
    key?: string | undefined;
    type?: string | undefined;
    filterFileName?: string | undefined;
    legendLabels?: string[] | undefined;
    valueColors?: string[] | undefined;
    yAxisLeftLabel?: string | undefined;
    yAxisRightLabel?: string | undefined;
    graphs?: Item[] | undefined;
    display?: { [key: string]: boolean; } | undefined;
}

export interface MapMarkerDTO {
    name?: string | undefined;
    country?: string | undefined;
    coordinates?: number[] | undefined;
    value?: number;
    type?: string | undefined;
}

export interface TVAVariationDTO {
    date?: Date;
    yearMonth?: string | undefined;
    val1?: number;
    val2?: number;
    val3?: number;
    val4?: number;
}

export interface TierDTO {
    displayName?: string | undefined;
    fileName?: string | undefined;
}

export interface BalanceDataDTO {
    name?: string | undefined;
    solde?: number;
    absoluteSolde?: number;
}

export interface VATAmountDTO {
    month?: string | undefined;
    amount?: number;
}

export interface DelayedPaymentDTO {
    name?: string | undefined;
    amount?: number;
    absAmount?: number;
}

export interface DeptInterestDTO {
    name?: string | undefined;
    dept?: number;
    interest?: number;
}

export interface CashFlowDTO {
    source?: string | undefined;
    destination?: string | undefined;
    amount?: number;
    type?: string | undefined;
}

export interface TaxRateDTO {
    rate?: string | undefined;
    lines?: number;
}

export interface TaxRateThirdPartyDTO {
    name?: string | undefined;
    rate?: number;
}

export interface DateStratificationDTO {
    period?: Date;
    total?: number;
    percentage?: number;
}

export interface DataTable {
    columns?: string[] | undefined;
    data?: string | undefined;
}

export interface CountryRuleDTO {
    countryName?: string | undefined;
    rule?: string | undefined;
}

export interface InvoiceIdsRequest {
    ids?: number[] | undefined;
    overrideLocks?: boolean;
    autoValidation?: boolean;
}

export interface GenerateInvoicesRequest {
    invoices?: InvoiceInfo[] | undefined;
    overrideLocks?: boolean;
}

export interface InvoiceInfo {
    date?: Date;
    payDate?: Date;
    id?: string | undefined;
}

export interface SearchNReplaceRequest {
    id?: number;
    expression?: string | undefined;
    replace?: string | undefined;
    caseSensitive?: boolean;
    wholeWord?: boolean;
    firstOccurence?: boolean;
}

export interface BNCInvoice {
    emplid?: string | undefined;
    invoiceNumber?: number;
    status?: BNCStatus | undefined;
    creationDate?: Date | undefined;
    editionDate?: Date | undefined;
    submissionDate?: Date | undefined;
    comment?: string | undefined;
    invoiceURL?: string | undefined;
    payDate?: Date | undefined;
    invoiceReference?: string | undefined;
    alerts?: BNCAlertType | undefined;
    invoicePDFURL?: string | undefined;
    id?: number;
    dafSubmissionDate?: Date | undefined;
    htInvoiceAmount?: number;
    invoiceAmount?: number;
    tvaAmount?: number;
    tvaRate?: number;
    agaMember?: boolean | undefined;
    bncEmployee?: BNCEmployee | undefined;
    bncInvoiceEvents?: BNCInvoiceEvent[] | undefined;
    bncInvoiceEntries?: BNCInvoiceEntry[] | undefined;
    isSelected?: boolean;
    hasTva?: boolean;
    isMale?: boolean;
    date?: string | undefined;
    prettyEditionDate?: string | undefined;
    month?: string | undefined;
    year?: string | undefined;
    accountLabel?: string | undefined;
    lastDayOfTheMonth?: number;
    fileName?: string | undefined;
    alert?: BNCAlert | undefined;
}

export enum BNCStatus {
    Initialization = 1,
    Creation = 2,
    ToBeCheck = 3,
    ValidationRunning = 4,
    Validated = 5,
    EmployeeSent = 6,
    EmployeeValidated = 7,
    AutoEmployeeValidated = 8,
    ToBeModified = 9,
    HRJobDone = 10,
    SendingToAccountingService = 11,
    SentToAccountingService = 12,
    Alerts = 13,
    OffProcess = 14,
    Error = -1,
}

export enum BNCAlertType {
    FirstInvoice = 1,
    UnpaidLeave = 2,
    PayAmountDifferent = 4,
}

export interface BNCEmployee {
    emplid?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    gender?: string | undefined;
    businessUnit?: string | undefined;
    fullTimeEquivalent?: number | undefined;
    contractType?: string | undefined;
    payMonth?: number | undefined;
    salary?: number | undefined;
    bonus?: number | undefined;
    homeAddressLine1?: string | undefined;
    homeAddressLine2?: string | undefined;
    homeAddressPostalCode?: string | undefined;
    homeAddressCity?: string | undefined;
    homeAddressCountry?: string | undefined;
    location?: string | undefined;
    businessAddressLine1?: string | undefined;
    businessAddressLine2?: string | undefined;
    businessAddressPostalCode?: string | undefined;
    businessAddressCity?: string | undefined;
    businessAddressCountry?: string | undefined;
    hireDate?: Date | undefined;
    terminationDate?: Date | undefined;
    bankName?: string | undefined;
    bankCountry?: string | undefined;
    bankBIC?: string | undefined;
    bankIBAN?: string | undefined;
    siret?: string | undefined;
    tvaId?: string | undefined;
    tvaCode?: string | undefined;
    tvaRate?: number | undefined;
    comptaGeneraleCode?: string | undefined;
    comptaAnalytiqueCode?: string | undefined;
    vendorID?: string | undefined;
    costCenter?: string | undefined;
    mandatSigne?: boolean;
    autoFacturationActive?: boolean;
    retrocessionSansSolde?: boolean;
    traitementManuel?: boolean;
    lastUpdatedUtcDateTime?: Date | undefined;
    disabled?: boolean;
    id?: number;
    email?: string | undefined;
    agaMember?: boolean | undefined;
    comment?: string | undefined;
    bncEmployeeEvents?: BNCEmployeeEvent[] | undefined;
    bncInvoices?: BNCInvoice[] | undefined;
    needManualCheck?: boolean;
    actionsRunning?: boolean;
    displayTvaId?: string | undefined;
    displaySiret?: string | undefined;
}

export interface BNCEmployeeEvent {
    id?: number;
    emplid?: string | undefined;
    creationDate?: Date;
    type?: number;
    message?: string | undefined;
    userName?: string | undefined;
    bncEmployee?: BNCEmployee | undefined;
}

export interface BNCInvoiceEvent {
    id?: number;
    bncInvoiceId?: number;
    creationDate?: Date;
    type?: number;
    message?: string | undefined;
    userName?: string | undefined;
    bncInvoice?: BNCInvoice | undefined;
}

export interface BNCInvoiceEntry {
    id?: number;
    type?: BNCEntryType;
    order?: number;
    bncInvoiceId?: number;
    name?: string | undefined;
    account?: string | undefined;
    amount?: number;
    postingKey?: string | undefined;
    taxCode?: string | undefined;
    taxAmount?: number;
    costCenter?: string | undefined;
    matGrpSubCat?: string | undefined;
    text?: string | undefined;
    bold?: boolean;
    editable?: boolean;
}

export enum BNCEntryType {
    Standard = 0,
    HT = 1,
    TTC = 2,
    TVA = 3,
}

export interface BNCAlert {
    type?: BNCAlertType;
}

export interface ReportRequest {
    date?: Date | undefined;
}

export interface EmployeeDataDTO {
    emplid?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    autoFacturationActive?: boolean;
    mandatSigne?: boolean;
    siret?: string | undefined;
    tvaId?: string | undefined;
    tvaRate?: number;
    comptaAnalytiqueCode?: string | undefined;
    comptaGeneraleCode?: string | undefined;
    costCenter?: string | undefined;
    vendorId?: string | undefined;
    retrocessionSansSolde?: boolean;
    agaMember?: boolean;
}

export interface EntityDTO {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    creatorId?: string;
    creatorName?: string | undefined;
    fileContainerId?: string;
    type?: EntityType;
    logoPath?: string | undefined;
    logo?: string | undefined;
    parentId?: string;
    children?: EntityDTO[] | undefined;
}

export interface FileProgressState {
    id?: string;
    progress?: number;
    status?: FileStatus;
}

export interface OfficeDTO {
    id?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    mapUrl?: string | undefined;
    postalCode?: string | undefined;
    streets?: string[] | undefined;
    telephone?: string | undefined;
    link?: string | undefined;
}

export interface ContactMessage {
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactEmail?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
}

export interface CspReportRequest {
    cspReport?: CspReport | undefined;
}

export interface CspReport {
    id?: string;
    documentUri?: string | undefined;
    referrer?: string | undefined;
    violatedDirective?: string | undefined;
    effectiveDirective?: string | undefined;
    originalPolicy?: string | undefined;
    blockedUri?: string | undefined;
    statusCode?: number;
    creationDate?: Date;
}

export interface ModelContextDTO {
    entities?: number;
    ownerships?: number;
    synthesis?: SynthesisDTO[];
    data?: string;
}

export interface SynthesisDTO {
    code?: string;
    rule?: string;
    gloBEIncome?: number;
    currentTax?: number;
    defferedTax?: number;
    coveredTax?: number;
    sbie?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// @ts-nockeck
// @ts-ignore
/* @ts-ignore */